import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives";
import type { AllRouteEndpoints } from "../routeTypes";

export const postDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
];

export const putDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
  decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
];

export const deleteDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
  decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
];
